const CACHE_KEY = 'waitlist_client';

interface WaitlistClientCache {
  name: string;
  email: string;
  discord?: string;
}

export function getWaitlistCache(): WaitlistClientCache | null {
  try {
    const cached = sessionStorage.getItem(CACHE_KEY);
    return cached ? JSON.parse(cached) : null;
  } catch {
    return null;
  }
}

export function setWaitlistCache(data: WaitlistClientCache): void {
  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify(data));
  } catch {
    // Session storage not available (SSR or private browsing)
  }
}

export function clearWaitlistCache(): void {
  try {
    sessionStorage.removeItem(CACHE_KEY);
  } catch {
    // Session storage not available
  }
}
